<template>
  <Teleport to="body">
    <transition name="fade">
      <component
        :is="uiStore.getDynamicMobilePanel.component"
        v-model="uiStore.getDynamicMobilePanel.value"
        v-bind="uiStore.getDynamicMobilePanel.data"
        v-on="uiStore.getDynamicMobilePanel.events"
        @update:model-value="uiStore.cleanMobilePanel"
      />
    </transition>
  </Teleport>
</template>

<script setup lang="ts">
const uiStore = useUiStore()
</script>

<style scoped></style>
